import { createSlice } from '@reduxjs/toolkit'

// general imports
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import { updateUserPhoneNumberThunk } from '../thunks/user-profile.thunk'

export type updateUserPhoneNumberState = {
  // eslint-disable-next-line
  requestResponse: ApiRequestDataType<any>
}

export const initialState: updateUserPhoneNumberState = {
  requestResponse: {
    status: ApiRequestStatus.IDLE,
    data: null,
  },
}

const updateUserPhoneNumberSlice = createSlice({
  name: 'updateUserPhoneNumberSlice',
  initialState: initialState,
  reducers: {
    resetupdateUserPhoneNumberState: (state) => {
      ;(state.requestResponse.status = ApiRequestStatus.IDLE), (state.requestResponse.data = null)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUserPhoneNumberThunk.pending, (state) => {
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .addCase(updateUserPhoneNumberThunk.fulfilled, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.FULFILLED

        // state.requestResponse.data = action.payload.description
      })
      .addCase(updateUserPhoneNumberThunk.rejected, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
  },
})

export const { resetupdateUserPhoneNumberState } = updateUserPhoneNumberSlice.actions
export default updateUserPhoneNumberSlice.reducer
